<template>
  <div class="reports-filter">
    <button
      :class="[
        'reports-filter__header',
        {
          'reports-filter__header--open': isOpen,
        },
      ]"
      @click="toggleFilters"
    >
      <p class="reports-filter__heading">
        {{ $t('common.reports.show_filters') }}
      </p>
      <img
        :class="[
          'reports-filter__chevron',
          {
            'reports-filter__chevron--open': isOpen,
          },
        ]"
        width="32"
        height="32"
        src="@/assets/icons/16-chevron-down-white.svg?url"
        alt=""
      />
    </button>
    <div v-if="isOpen" class="reports-filter__content">
      <section class="reports-filter__section">
        <p class="reports-filter__subheading">
          {{ $t('common.reports.language') }}
        </p>
        <FormBaseCheckbox
          v-model="filtersDraft.shouldHaveEnglish"
          label-i18-path="common.reports.english"
        />
        <FormBaseCheckbox
          v-model="filtersDraft.shouldHaveGerman"
          label-i18-path="common.reports.german"
        />
      </section>
      <div class="reports-filter__divider" />
      <section class="reports-filter__section">
        <p class="reports-filter__subheading">
          {{ $t('common.reports.topics') }}
        </p>
        <FormBaseCheckbox
          v-for="tag in tagStories"
          :key="tag.name"
          v-model="filtersDraft.tags[tag.uuid]"
          class="checkbox-group__consent"
          :label="tag.content.name"
        />
      </section>
      <div class="reports-filter__buttons">
        <BaseButton
          :title="$t('common.reports.reset')"
          outlined
          @click="onClearFilters"
        >
          <template #text>
            {{ $t('common.reports.reset') }}
          </template>
        </BaseButton>
        <BaseButton :title="$t('common.reports.apply')" @click="applyFilters">
          <template #text>
            {{ $t('common.reports.apply') }}
          </template>
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const reportsStore = useReportsStore()

const { filters, filtersDraft, checkedTags, tagStories } =
  storeToRefs(reportsStore)
const { clearFilters } = reportsStore

const isOpen = ref(false)

const toggleFilters = () => {
  isOpen.value = !isOpen.value
}

const onClearFilters = () => {
  filtersDraft.value.shouldHaveEnglish = false
  filtersDraft.value.shouldHaveGerman = false
  filtersDraft.value.tags = {}

  clearFilters()
}

const applyFilters = () => {
  filters.value.shouldHaveEnglish = unref(filtersDraft.value.shouldHaveEnglish)
  filters.value.shouldHaveGerman = unref(filtersDraft.value.shouldHaveGerman)
  checkedTags.value = {
    ...unref(filtersDraft.value.tags),
  }
}
</script>

<style lang="scss" scoped>
.reports-filter {
  &__header {
    background-color: var(--cobalt-800);
    color: white;
    padding: 12px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    border-radius: 16px;

    &--open {
      border-radius: 16px 16px 0 0;
    }
  }

  &__heading {
    margin: 0;
    font-size: var(--font-size-paragraph-s);
    font-weight: var(--font-weight-paragraph-bold);
    line-height: 26px;
  }

  &__content {
    padding: 32px;
    background-color: white;
    border-radius: 0 0 16px 16px;
  }

  &__section {
    margin-bottom: 28px;
  }

  &__subheading {
    @include heading-subheading;
  }

  &__chevron {
    width: 16px;
    transition: transform 0.3s ease-in-out;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__buttons {
    display: flex;
    justify-content: flex-start;
    column-gap: 20px;
  }
}
</style>
